/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Messages_VisibleInputs */

const cs_messages_visible = /** @type {(inputs: Messages_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viditelné`)
};

const en_messages_visible = /** @type {(inputs: Messages_VisibleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible`)
};

/**
* | output |
* | --- |
* | "Visible" |
*
* @param {Messages_VisibleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const messages_visible = /** @type {((inputs?: Messages_VisibleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Messages_VisibleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_messages_visible(inputs)
	return cs_messages_visible(inputs)
});